import { CSSProperties } from 'react'

const commonRow: CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'baseline',
}

const commonImage: CSSProperties = {
  objectFit: 'cover',
}

const sideImageWidth = 293

export const s = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  } as CSSProperties,
  firstRow: {
    ...commonRow,
    marginBottom: 8,
  } as CSSProperties,
  title: {
    margin: 0,
  },
  secondRow: {
    ...commonRow,
    fontSize: 24,
  } as CSSProperties,
  dateTime: {
    color: '#595959',
  },
  card: {
    marginTop: 32,
  },
  cardBody: {
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
  } as CSSProperties,
  image: {
    ...commonImage,
  } as CSSProperties,
  images: {
    root: {
      width: '100%',
      display: 'flex',
    } as CSSProperties,
    primary: {
      width: `calc(100% - ${sideImageWidth}px)`,
      ...commonImage,
    } as CSSProperties,
    side: {
      width: sideImageWidth,
      display: 'flex',
      flexDirection: 'column',
    } as CSSProperties,
    sideImages: {
      ...commonImage,
    } as CSSProperties,
  },
  confirmedGrid: {
    margin: '48px 48px 32px 30px',
    display: 'grid',
    gridTemplateColumns: '60px 1fr minmax(80px, 120px) 120px',
    gridTemplateRows: 'auto auto auto',
    gridTemplateAreas: '"tick confirmedAt cost blank" "tick address address details"',
    rowGap: 8,
    columnGap: 24,
    fontSize: 18,
  } as CSSProperties,
  tick: {
    gridArea: 'tick',
    fontSize: 60,
    color: '#72C040',
  },
  confirmedAt: {
    gridArea: 'confirmedAt',
    display: 'flex',
    flexDirection: 'column',
  } as CSSProperties,
  venueSpace: {
    fontSize: 24,
    fontWeight: 500,
  } as CSSProperties,
  cost: {
    gridArea: 'cost',
    alignSelf: 'end',
    fontSize: 24,
    overflowWrap: 'unset',
  } as CSSProperties,
  address: {
    gridArea: 'address',
    display: 'flex',
    gap: 16,
  },
  details: {
    gridArea: 'details',
    fontSize: 18,
    fontWeight: 600,
  } as CSSProperties,
  divider: {
    margin: 0,
  },
  contactDetails: {
    margin: 32,
  },
  attachment: {
    margin: 32,
  },
}
